export default __webpack_public_path__ + "static/media/event.56a0fcbd.png";